const GOOGLE_REGISTRATION_KEY = "google_registration";
const GOOGLE_AUTH_NOTICE_KEY = "google_auth_notice";

export type GoogleRegistrationState = {
  registrationToken: string;
  email: string;
};

export const saveGoogleRegistration = (state: GoogleRegistrationState) => {
  sessionStorage.setItem(GOOGLE_REGISTRATION_KEY, JSON.stringify(state));
};

export const getGoogleRegistration = (): GoogleRegistrationState | null => {
  const value = sessionStorage.getItem(GOOGLE_REGISTRATION_KEY);
  if (!value) return null;

  try {
    const state = JSON.parse(value) as Partial<GoogleRegistrationState>;
    if (!state.registrationToken || !state.email) return null;
    return {
      registrationToken: state.registrationToken,
      email: state.email,
    };
  } catch {
    return null;
  }
};

export const clearGoogleRegistration = () => {
  sessionStorage.removeItem(GOOGLE_REGISTRATION_KEY);
};

export const setGoogleAuthNotice = (message: string) => {
  sessionStorage.setItem(GOOGLE_AUTH_NOTICE_KEY, message);
};

export const takeGoogleAuthNotice = () => {
  const message = sessionStorage.getItem(GOOGLE_AUTH_NOTICE_KEY);
  sessionStorage.removeItem(GOOGLE_AUTH_NOTICE_KEY);
  return message;
};
